import React from "react";
import { MARQUEE } from "@/data/siteContent";

export default function Marquee({ language }) {
  const items = MARQUEE[language];
  const copy = [...items, ...items];
  return (
    <div className="marquee-wrap" aria-label="Protech services ribbon" data-testid="service-marquee">
      <div className="marquee-track">
        {copy.map((item, index) => <div className="marquee-copy" key={`${item}-${index}`}><span>{item}</span><b>◆</b></div>)}
      </div>
    </div>
  );
}
